const ITEMS = [
  "Sovereign Custody",
  "AES-256 Envelope Encryption",
  "Atomic Multi-Chain Swaps",
  "Zero-Knowledge Architecture",
  "Hardware Enclave Sync",
  "Open Security Audits",
  "Quantum-Ready Cryptography",
  "Zero-Trace Privacy",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative border-y border-white/5 bg-obsidian/60 py-5 overflow-hidden mask-fade-x" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee gap-0">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-8 px-8 font-mono text-xs tracking-[0.28em] uppercase text-slate-500 whitespace-nowrap">
            {item}
            <span className="text-gold/60">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};
